import React from 'react';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import GenericCard from '../GenericCards';

type VideoCardProps = {
  title: string;
  videoLink: string;
  videoCardImg: string;
  alt: string;
  onClick?: () => void;
};

const VideoCard = (props: VideoCardProps) => {
  return (
    <div className={'video-card-container'}>
      <GenericCard className={'video-card-body'} variant={'white'}>
        <div className={'img-btn-container'}>
          <img
            className={'video-img'}
            src={props.videoCardImg}
            alt={props.alt}
          />
          <Link
            onClick={props.onClick}
            className={'video-play'}
            to={props.videoLink}
          >
            <FontAwesomeIcon icon={light('play')} />
          </Link>
        </div>
        <div className={'video-title'}>{props.title}</div>
      </GenericCard>
    </div>
  );
};

export default VideoCard;
